import {
  Alert,
  Box,
  Button,
  Divider,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Link as LinkIcon,
  Title as TitleIcon,
} from "@mui/icons-material";

export default function SponsorForm({
  countryCodes,
  editingId,
  fieldErrors,
  generalErrors,
  form,
  linkForm,
  links,
  onAddLink,
  onCancel,
  onChange,
  onDeleteLink,
  onFileChange,
  onLinkChange,
  onSubmit,
  photoFile,
}) {
  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: "16px",
        border: "2px solid #e0f2e9",
        backgroundColor: "#fcffff",
      }}
    >
      <form onSubmit={onSubmit} encType="multipart/form-data">
        <Box display="flex" flexDirection="column" gap={2}>
          {generalErrors.length > 0 && (
            <Box width="100%">
              {generalErrors.map((msg, i) => (
                <Alert severity="error" key={i} sx={{ mb: 1 }}>
                  {msg}
                </Alert>
              ))}
            </Box>
          )}

          <TextField
            label="Nombre del Negocio o emprendimiento"
            name="business_name"
            value={form.business_name}
            onChange={onChange}
            error={Boolean(fieldErrors.business_name)}
            helperText={fieldErrors.business_name}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          />

          <TextField
            label="Direccion"
            name="address"
            value={form.address}
            onChange={onChange}
            error={Boolean(fieldErrors.address)}
            helperText={fieldErrors.address}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          />

          <Box display="flex" gap={1} width="100%">
            <TextField
              select
              label="Lada"
              name="phone_lada"
              value={form.phone_lada}
              onChange={onChange}
              sx={{
                width: "30%",
                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
              }}
            >
              {countryCodes.map((c) => (
                <MenuItem key={c.code} value={c.code}>
                  {c.label} ({c.code})
                </MenuItem>
              ))}
            </TextField>

            <TextField
              label="Telefono"
              name="phone"
              value={form.phone}
              onChange={onChange}
              error={Boolean(fieldErrors.phone)}
              helperText={fieldErrors.phone}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
              }}
            />
          </Box>

          <TextField
            label="Notas"
            name="notes"
            value={form.notes}
            onChange={onChange}
            error={Boolean(fieldErrors.notes)}
            helperText={fieldErrors.notes}
            fullWidth
            multiline
            rows={3}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          />

          <Button
            variant="outlined"
            component="label"
            fullWidth
            sx={{
              py: 1.5,
              borderRadius: "50px",
              backgroundColor: "#1B8D4B",
              color: "white",
              "&:hover": {
                backgroundColor: "#14703B",
              },
            }}
          >
            {photoFile ? photoFile.name : "Seleccionar imagen"}
            <input type="file" hidden onChange={onFileChange} />
          </Button>
          {fieldErrors.photo && <Alert severity="error">{fieldErrors.photo}</Alert>}

          <Divider sx={{ my: 1 }} />

          <Typography
            variant="h6"
            sx={{
              color: "#1B8D4B",
              fontFamily: "'Comic Relief', cursive",
            }}
          >
            Enlaces del Patrocinador
          </Typography>

          <Box display="flex" gap={2} alignItems="center">
            <TextField
              label="Titulo"
              name="title"
              value={linkForm.title}
              onChange={onLinkChange}
              error={Boolean(fieldErrors.link_title)}
              helperText={fieldErrors.link_title}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <TitleIcon sx={{ color: "#FFA500" }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
              }}
            />

            <TextField
              label="URL"
              name="url"
              value={linkForm.url}
              onChange={onLinkChange}
              error={Boolean(fieldErrors.link_url)}
              helperText={fieldErrors.link_url}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LinkIcon sx={{ color: "#FFA500" }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
              }}
            />

            <Button
              onClick={onAddLink}
              variant="contained"
              sx={{
                width: "180px",
                borderRadius: "50px",
                backgroundColor: "#1B8D4B",
                "&:hover": { backgroundColor: "#14703B" },
              }}
            >
              Agregar
            </Button>
          </Box>
          {fieldErrors.links && <Alert severity="error">{fieldErrors.links}</Alert>}

          <List sx={{ width: "100%" }}>
            {links.map((link, index) => (
              <ListItem
                key={`${link.title}-${link.url}-${index}`}
                secondaryAction={
                  <IconButton
                    edge="end"
                    onClick={() => onDeleteLink(index)}
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                }
                sx={{
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  mb: 1,
                }}
              >
                <ListItemText primary={link.title} secondary={link.url} />
              </ListItem>
            ))}
          </List>

          <Box display="flex" gap={2} mt={2}>
            {editingId && (
              <Button
                variant="outlined"
                fullWidth
                onClick={onCancel}
                sx={{
                  py: 1.5,
                  borderRadius: "50px",
                  color: "#1B8D4B",
                  borderColor: "#1B8D4B",
                  "&:hover": {
                    backgroundColor: "#e0f2e9",
                    borderColor: "#1B8D4B",
                  },
                }}
              >
                Cancelar
              </Button>
            )}
            <Button
              variant="contained"
              type="submit"
              fullWidth
              sx={{
                py: 1.5,
                borderRadius: "50px",
                backgroundColor: "#1B8D4B",
                "&:hover": { backgroundColor: "#14703B" },
              }}
            >
              {editingId ? "Actualizar" : "Agregar"}
            </Button>
          </Box>
        </Box>
      </form>
    </Paper>
  );
}
